import * as d3 from 'd3'
export default {
  methods: {

    draw_Scrollbar() {

      if(this.scroll.content.height < 290) return

      let bar = this.scroll.bar
      let scroll = this.canvasForm
      .append('g')
      .attr('id', `CANVAS_SCROLL_${this.localId}`)
      .attr('transform', `translate(${this.scroll.viewbox.x + this.scroll.viewbox.width}, ${this.scroll.viewbox.y})`)

      scroll
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', bar.width).attr('height', this.scroll.viewbox.height)
      .attr('fill', '#E0E0DF').attr('opacity', .3)

      scroll
      .append('rect')
      .attr('id', `SCROLL_BAR_${this.localId}`)
      .attr('x', 0).attr('y', 0)
      .attr('width', bar.width).attr('height', this.scroll.bar.size)
      .attr('fill', bar.color).attr('opacity', bar.opacity)
      .call(
        d3.drag()
        .on('drag', (event) => this.dragging(event))
      )
    },


    dragging(event) {
      let bar = this.scroll.bar
      let viewbox = this.scroll.viewbox

      bar.y = bar.y + event.dy

      if(bar.y < 0) bar.y = 0
      if((bar.y + bar.size) > viewbox.height) bar.y = bar.space

      d3.select(`#${this.localId}`).select(`#SCROLL_BAR_${this.localId}`).attr('y', bar.y)

      let bar_ratio = bar.y / bar.space
      let y_ = viewbox.space * bar_ratio
      d3.select(`#${this.localId}`).select(`#CONTENTS_${this.localId}`).attr('transform', `translate(${this.table.x}, ${-y_ + viewbox.y})`)

    },


  }
}